import { FC, useEffect, useState } from "react";
import { LocalStorage } from "src/framework/commons";
import { InputComboBoxList, InputDate, InputMoney } from "src/framework/components/forms";
import { CacheType } from "src/store/global.store";
import { IParcelasDisponiveis, Simulacao } from "src/types";
import moment from "moment";

export interface SimulacaoFormProperties {
    data: Simulacao,
    isPessoaJuridica?: boolean,
    onChange: (newValues: Simulacao) => void,
}

const makeParcelas = (parcelas: CacheType<IParcelasDisponiveis> | null) => {
    if (!parcelas) {
        return [];
    }

    return parcelas?.data?.parcelas?.map((_p) => {
        return {
            name: `${String(_p)}x`,
            value: String(_p),
        }

    })
}



const SimulacaoForm: FC<SimulacaoFormProperties> = ({
    data,
    isPessoaJuridica = false,
    onChange
}) => {

    const [parcelasState, setParcelasState] = useState<any>(null)
    const parcelasList = makeParcelas(LocalStorage.get("solar.parcelasDisponiveis", true))

    useEffect(() => {
        const _parcela = parcelasList?.find((_p: any) => data?.parcelas?.toString() === _p.value) || null
        setParcelasState(_parcela);
    }, [data.parcelas]);

    const getMaxDate = () => {
        const now = moment().add(-18, "years")
        return now.toDate();
    }

    return <div className="SimulacaoForm">
        <div className="row">
            
            <div className="X12 M4">
                <InputMoney
                    fullWidth
                    label={`${isPessoaJuridica ? "Faturamento médio mensal" : "Renda mensal/Conjunta"}`}
                    value={data?.valor_mensal_renda_faturamento}
                    isNumberValue
                    onChangeValue={(newValue) => {
                        if (data?.valor_mensal_renda_faturamento !== undefined || data?.valor_mensal_renda_faturamento !== null) {
                            data.valor_mensal_renda_faturamento = newValue.numberValue
                            onChange(data)
                        }
                    }}
                />

            </div>
            <div className="X12 M4">
                <InputDate
                    margin="normal"
                    fullWidth
                    size="small"
                    maxDate={isPessoaJuridica ? undefined : getMaxDate()}
                    label={`${isPessoaJuridica ? "Data de fundação da empresa" : "Data de nascimento"}`}
                    
                    value={data?.data_nascimento_fundacao}
                    onChange={(event: any) => {
                        data.data_nascimento_fundacao = event
                        onChange(data)
                    }}
                />
            </div>
            <div className="X12 M4">
                <InputComboBoxList
                    label="Preferência de parcelas"
                    options={parcelasList}

                    value={parcelasState}
                    onChange={(_parcela) => {
                        if (data?.parcelas !== null || data?.parcelas !== undefined) {
                            data.parcelas = _parcela?.value ? Number(_parcela.value) : 0
                        }
                        setParcelasState(_parcela);
                    }}

                    textField="name"
                    valueField="value"
                />
            </div>
            
        </div>
    </div>
}

export { SimulacaoForm }